;(function($, trackFindaEvents){
    'use strict';

    var rnn = window.rnn,
        shortlistCookieName = '_lcsl',
        googleShortListCookie = '_glcsl';

    function getShortlistCookie() {
        return Cookies.get(shortlistCookieName);
    }

    function setShortlistCookie(value) {
        Cookies.set(shortlistCookieName, value, { expires: 7, path: '/'});
        updateShortlistUIData();
    }

    function getGoogleTrackingShortlistCookie() {
        return Cookies.get(googleShortListCookie);
    }

    function setGoogleTrackingShortlistCookie(value) {
        Cookies.set(googleShortListCookie, value, { expires: 7, path: '/'});
    }

    function addToShortlist(id) {
        var cookie = getShortlistCookie();
        if (!!cookie) {
            if (cookie !== id &&
                cookie.indexOf(id + '.') === -1 &&
                cookie.indexOf('.' + id) === -1 &&
                cookie.indexOf('.' + id + '.') === -1) {
                setShortlistCookie(cookie + '.' + id);
            }
        } else {
            setShortlistCookie(id);
        }
    }

    function removeFromShortlist(id) {
        var cookie = getShortlistCookie();
        var ids = [];
        if (!!cookie) {
            _.each(cookie.split('.'), function (cookieId) {
                if (id !== cookieId) {
                    ids.push(cookieId);
                }
            });
            setShortlistCookie(ids.join('.'));
        }
    }

    function updateShortlistLinks() {

        var $shortlistLinks = $('[data-lc-shortlist-link]');

        if ($shortlistLinks.length > 0) {

            var cookie = getShortlistCookie();
            var url = rnn.site.shortlistUrl;

            if (!!cookie) {
                url = url + btoa(cookie) + '/';
            }

            $shortlistLinks.each(function () {
                var $link = $(this);
                if (!!cookie) {
                    $link.attr('href', url);
                    if (history && history.pushState && $('[data-lc-shortlist-cookie]').length) {
                        history.pushState(null, null, url);
                    }
                } else {
                    $link.attr('href', 'javascript:void(0);');
                }
            });
        }
    }

    function updateShortlistCounts() {

        var $shortlistCount = $('[data-lc-shortlist-count]');

        if ($shortlistCount.length > 0) {
            var cookie = getShortlistCookie();
            if (!!cookie) {
                $shortlistCount.text(cookie.split('.').length).parent().addClass('shortlist-populated');
            } else {
                $shortlistCount.text('0').parent().removeClass('shortlist-populated');
            }
        }
    }

    function updateShortlistUIData() {
        updateShortlistLinks();
        updateShortlistCounts();
    }

    function cleanShortlist() {

        var $shortlistResults = $('[data-lc-shortlist-cookie]');

        if ($shortlistResults.length > 0) {

            var cookie = getShortlistCookie();
            var oldCookie = atob($shortlistResults.data('lcShortlistCookie') || '');

            // Should only run once when we are viewing a shortlist
            if (!!cookie && oldCookie === cookie) {
                setShortlistCookie($('.shortlist-toggle').map(function () {
                    return $(this).data('lcResultId');
                }).get().join('.'));
                $('.search-results').addClass('classifieds-personal-shortlist');
            }
        }
    }

    function g_an_track(id, $el){
        var g_cookie = getGoogleTrackingShortlistCookie();
        if (!!g_cookie) {
            if (g_cookie !== id &&
                g_cookie.indexOf(id + '.') === -1 &&
                g_cookie.indexOf('.' + id) === -1 &&
                g_cookie.indexOf('.' + id + '.') === -1) {
                setGoogleTrackingShortlistCookie(g_cookie + '.' + id);
                trackFindaEvents.track_shortlist($el);
            }
        }else{
            trackFindaEvents.track_shortlist($el);
            setGoogleTrackingShortlistCookie(id);
        }
    }

    function initShortlistToggles() {

        var $toggles = $('.shortlist-toggle');

        if ($toggles.length > 0) {
            var cookie = getShortlistCookie();

            // Set checkboxes based on current shortlist
            if (!!cookie) {
                _.each(cookie.split('.'), function (id) {
                    var $checkbox = $('*[data-lc-result-id="' + id + '"]');

                    $checkbox.prop('checked', true);
                });
            }

            // Bind shortlist toggles to all result checkboxes
            $toggles.on('change', function (event) {
                event.stopPropagation();
                var $toggle = $(this),
                    $label = $toggle.next('label').children('span'),
                    id = $toggle.data('lcResultId');

                //If there are two buttons for the same item select them both
                if ($('*[data-lc-result-id="' + id + '"]').length > 1) {
                    var checkedState = $toggle.prop('checked');
                    $('*[data-lc-result-id="' + id + '"]').prop('checked', checkedState);
                }

                if ($toggle.prop('checked')) {
                    addToShortlist('' + id);
                    g_an_track('' + id, $toggle);
                } else {
                    removeFromShortlist('' + id);
                }
            });
        }
    }

    function initShortlist() {
        cleanShortlist();
        initShortlistToggles();
        updateShortlistUIData();
    }

    rnn.modules.register('shortList', {
        init: initShortlist
    });

})(jQuery, window.rnn.modules.trackFindaEvents);
